// // src/services/recordedSessionsService.js
// import axios from 'axios';
// import { CONSTANTS } from '../constants/Constants';

// // Get all recorded sessions
// export const getRecordedSessions = async () => {
//   try {
//     const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions`);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching recorded sessions:', error);
//     throw error;
//   }
// };

// // Get a single recorded session by ID
// export const getRecordedSessionById = async (id) => {
//   try {
//     const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/${id}`);
//     return response.data;
//   } catch (error) {
//     console.error(`Error fetching recorded session with ID ${id}:`, error);
//     throw error;
//   }
// };

// // Get related sessions for a specific session
// export const getRelatedSessions = async (id) => {
//   try {
//     const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/related/${id}`);
//     return response.data;
//   } catch (error) {
//     console.error(`Error fetching related sessions for ID ${id}:`, error);
//     throw error;
//   }
// };

// // Get all unique subjects
// export const getSubjects = async () => {
//   try {
//     const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/subjects`);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching subjects:', error);
//     throw error;
//   }
// };

// // Filter recorded sessions
// export const filterRecordedSessions = async (subject, type, searchQuery) => {
//   try {
//     let url = `${CONSTANTS.APIURL}/api/recorded-sessions/filter?`;
    
//     if (subject && subject !== 'all') {
//       url += `subject=${subject}&`;
//     }
    
//     if (type && type !== 'all') {
//       url += `type=${type}&`;
//     }
    
//     if (searchQuery) {
//       url += `search=${searchQuery}`;
//     }
    
//     const response = await axios.get(url);
//     return response.data;
//   } catch (error) {
//     console.error('Error filtering recorded sessions:', error);
//     throw error;
//   }
// };
// src/services/recordedSessionsService.js
import axios from 'axios';
import { CONSTANTS } from '../constants/Constants';
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';

// Get all recorded sessions with filters and pagination
export const getRecordedSessions = async (filters = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = '',
      subject,
      type,
      class: classFilter,
      language,
      courseid,
      sort = 'newest'
    } = filters;

    // Build query parameters
    const params = new URLSearchParams();
    
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (search) params.append('search', search);
    if (subject && subject !== 'all') params.append('subject', subject);
    if (type && type !== 'all') params.append('type', type);
    if (classFilter && classFilter !== 'all') params.append('class', classFilter);
    if (language && language !== 'all') params.append('language', language);
    if (courseid && courseid !== 'all') params.append('courseid', courseid);
    if (sort) params.append('sort', sort);

    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching recorded sessions:', error);
    throw error;
  }
};

// Get a single recorded session by ID
export const getRecordedSessionById = async (id) => {
  try {
    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching recorded session with ID ${id}:`, error);
    throw error;
  }
};
export const getChapters = async (filters) => {
  try {
    let chaptersQuery = collection(db, "chapters");
    const conditions = [];

    // Add filters to Firestore query
    if (filters.courseid && filters.courseid !== "all") {
      conditions.push(where("courseId", "==", filters.courseid));
    }
    if (filters.class && filters.class !== "all") {
      conditions.push(where("class", "==", filters.class));
    }
    if (filters.language && filters.language !== "all") {
      conditions.push(where("language", "==", filters.language));
    }

    // Apply conditions to query
    if (conditions.length > 0) {
      chaptersQuery = query(chaptersQuery, ...conditions, orderBy("createdAt", "desc"));
    } else {
      chaptersQuery = query(chaptersQuery, orderBy("createdAt", "desc"));
    }

    const querySnapshot = await getDocs(chaptersQuery);
    let chapters = [];

    querySnapshot.forEach((doc) => {
      chapters.push({
        _id: doc.id,
        ...doc.data()
      });
    });

    // Client-side search filtering if search query exists
    if (filters.searchQuery && filters.searchQuery.trim()) {
      const searchTerm = filters.searchQuery.toLowerCase().trim();
      chapters = chapters.filter(chapter => 
        chapter.title?.toLowerCase().includes(searchTerm) ||
        chapter.description?.toLowerCase().includes(searchTerm) ||
        chapter.subject?.toLowerCase().includes(searchTerm)
      );
    }

    return {
      success: true,
      chapters: chapters
    };
  } catch (error) {
    console.error("Error fetching chapters from Firestore:", error);
    throw error;
  }
};

// Get sessions by chapter ID from Firestore
export const getSessionsByChapter = async (chapterId, filters = {}) => {
  try {
    let sessionsQuery = collection(db, "recordedSessions");
    const conditions = [where("chapterId", "==", chapterId)];

    // Add additional filters
    if (filters.courseid && filters.courseid !== "all") {
      conditions.push(where("courseId", "==", filters.courseid));
    }
    if (filters.class && filters.class !== "all") {
      conditions.push(where("class", "==", filters.class));
    }
    if (filters.language && filters.language !== "all") {
      conditions.push(where("language", "==", filters.language));
    }

    // Apply conditions and ordering
    sessionsQuery = query(
      sessionsQuery, 
      ...conditions, 
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(sessionsQuery);
    const sessions = [];

    querySnapshot.forEach((doc) => {
      sessions.push({
        _id: doc.id,
        ...doc.data()
      });
    });

    return {
      success: true,
      sessions: sessions
    };
  } catch (error) {
    console.error("Error fetching sessions by chapter from Firestore:", error);
    throw error;
  }
};
// Get related sessions for a specific session
export const getRelatedSessions = async (id) => {
  try {
    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/related/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching related sessions for ID ${id}:`, error);
    throw error;
  }
};

// Get all unique subjects
export const getSubjects = async () => {
  try {
    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/subjects`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subjects:', error);
    throw error;
  }
};

// Get filter options (subjects, types, classes, languages, courses)
export const getFilterOptions = async () => {
  try {
    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/filters`);
    return response.data;
  } catch (error) {
    console.error('Error fetching filter options:', error);
    throw error;
  }
};

// Filter recorded sessions (Enhanced version)
export const filterRecordedSessions = async (filters = {}) => {
  try {
    const {
      subject,
      type,
      searchQuery,
      class: classFilter,
      language,
      courseid
    } = filters;

    // Build query parameters
    const params = new URLSearchParams();
    
    if (subject && subject !== 'all') params.append('subject', subject);
    if (type && type !== 'all') params.append('type', type);
    if (classFilter && classFilter !== 'all') params.append('class', classFilter);
    if (language && language !== 'all') params.append('language', language);
    if (courseid && courseid !== 'all') params.append('courseid', courseid);
    if (searchQuery) params.append('search', searchQuery);

    const response = await axios.get(`${CONSTANTS.APIURL}/api/recorded-sessions/filter?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error filtering recorded sessions:', error);
    throw error;
  }
};

// Create a new recorded session (for admin)
export const createRecordedSession = async (sessionData) => {
  try {
    const response = await axios.post(`${CONSTANTS.APIURL}/api/recorded-sessions`, sessionData);
    return response.data;
  } catch (error) {
    console.error('Error creating recorded session:', error);
    throw error;
  }
};

// Update a recorded session (for admin)
export const updateRecordedSession = async (id, sessionData) => {
  try {
    const response = await axios.put(`${CONSTANTS.APIURL}/api/recorded-sessions/${id}`, sessionData);
    return response.data;
  } catch (error) {
    console.error(`Error updating recorded session with ID ${id}:`, error);
    throw error;
  }
};

// Delete a recorded session (for admin)
export const deleteRecordedSession = async (id) => {
  try {
    const response = await axios.delete(`${CONSTANTS.APIURL}/api/recorded-sessions/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting recorded session with ID ${id}:`, error);
    throw error;
  }
};

// Get sessions by specific filters (utility functions)
export const getSessionsByClass = async (classLevel) => {
  try {
    return await filterRecordedSessions({ class: classLevel });
  } catch (error) {
    console.error(`Error fetching sessions for class ${classLevel}:`, error);
    throw error;
  }
};

export const getSessionsByLanguage = async (language) => {
  try {
    return await filterRecordedSessions({ language });
  } catch (error) {
    console.error(`Error fetching sessions for language ${language}:`, error);
    throw error;
  }
};

export const getSessionsByCourse = async (courseid) => {
  try {
    return await filterRecordedSessions({ courseid });
  } catch (error) {
    console.error(`Error fetching sessions for course ${courseid}:`, error);
    throw error;
  }
};

// Get Kannada sessions
export const getKannadaSessions = async () => {
  try {
    return await filterRecordedSessions({ language: 'kannada' });
  } catch (error) {
    console.error('Error fetching Kannada sessions:', error);
    throw error;
  }
};

// Get English sessions
export const getEnglishSessions = async () => {
  try {
    return await filterRecordedSessions({ language: 'english' });
  } catch (error) {
    console.error('Error fetching English sessions:', error);
    throw error;
  }
};

// Search sessions with advanced filters
export const searchSessions = async (searchOptions = {}) => {
  try {
    const {
      query = '',
      filters = {},
      page = 1,
      limit = 10,
      sort = 'newest'
    } = searchOptions;

    return await getRecordedSessions({
      search: query,
      page,
      limit,
      sort,
      ...filters
    });
  } catch (error) {
    console.error('Error searching sessions:', error);
    throw error;
  }
};

// Get sessions with pagination
export const getSessionsPaginated = async (page = 1, limit = 10, filters = {}) => {
  try {
    return await getRecordedSessions({
      page,
      limit,
      ...filters
    });
  } catch (error) {
    console.error('Error fetching paginated sessions:', error);
    throw error;
  }
};

// Backward compatibility function (for existing code)
export const filterRecordedSessionsLegacy = async (subject, type, searchQuery) => {
  console.warn('filterRecordedSessionsLegacy is deprecated. Use filterRecordedSessions with object parameter instead.');
  return await filterRecordedSessions({
    subject,
    type,
    searchQuery
  });
};

// Export all functions
export default {
  getRecordedSessions,
  getRecordedSessionById,
  getRelatedSessions,
  getSubjects,
  getFilterOptions,
  filterRecordedSessions,
  createRecordedSession,
  updateRecordedSession,
  deleteRecordedSession,
  getSessionsByClass,
  getSessionsByLanguage,
  getSessionsByCourse,
  getKannadaSessions,
  getEnglishSessions,
  searchSessions,
  getSessionsPaginated,
  filterRecordedSessionsLegacy
};